import schedule from './schedule'

export default {
  objectmanager: {
    namespaced: true,
    modules: {
      schedule
    }
  }
}
